<template>
  <div id='box'>
    <div class="no-data-wrap" v-if="!liveRooms || liveRooms.length == 0">
      <img src="../../assets/live/no_data.png" />
    </div>
    <div v-for='(room, index) in liveRooms' :key="index" class='body'>
      <div class='content'>
        <div class='left'>
          <div class='room-title'>{{room.title}}</div>
          <div class='teachers'>
            <div class="name-style">
               讲师：{{getTeacherNames(room.teachers)}}
            </div>
            <!-- <span v-for='(teacher, index) in room.teachers' :key="index">
              <span>{{teacher.name}}</span>
              <span v-if='room.teachers.length !== 1'>
                <span v-if='room.teachers.length !== index+1'>、</span>
              </span>
            </span> -->
          </div>
          <div class='room-time'>
            {{room.begin_time}} - {{room.end_time.split(' ')[1]}}
          </div>
        </div>
        <div class='right' v-if="$store.getters.getUserType != 1 && (room.live_type === 1 || room.live_type === 5)">
          <enter-live-btn @click="enterLive(room)" class='pointer enter-room' v-if='room.status === 0' src='@/assets/live/liveing_icon.png'/>
          <no-start-btn @click="enterLive(room)" class='pointer not-begin' v-if='room.status === -1' src='@/assets/live/nostart_icon.png'/>
          <over-live-btn @click="enterLive(room)" class='pointer room-end' v-if='room.status === 2'  src='@/assets/live/over_icon.png'/>
          <enter-vod-btn @click="enterPlayback(room)" class='pointer replay' v-if='room.status === 1' src='@/assets/live/vod_icon.png'/>
        </div>
<!--        <div style="clear: both"></div> -->
      </div>
    </div>

  </div>
</template>

<script>
    import enterLiveBtn from './button/enterlive_btn.vue'
    import enterVodBtn from './button/entervod_btn.vue'
    import enterCourseBtn from './button/entercourse_btn.vue'
    import noStartBtn from './button/nostart_btn.vue'
    import overLiveBtn from './button/overlive_btn.vue'
export default {

  name: 'LiveRooms',
  props: ['liveRooms'],
  components:{
    enterLiveBtn,
    enterVodBtn,
    enterCourseBtn,
    noStartBtn,
    overLiveBtn
  },
  data () {
    return {
    }
  },
  methods: {
    getTimeShow(beginTime, endTime) {
      let beginYMD = beginTime.split(' ')[0]
      let beginHMS = beginTime.split(' ')[1]
      let endHMS = endTime.split(' ')[1]

      beginYMD = beginYMD.replace('')

    },
    getTeacherNames: function (teachers){
      let names = ''
      for (let i = 0; i < teachers.length; i++) {
        names += teachers[i].name
        if (i < (teachers.length - 1)) {
          names += '、'
        }
      }
      return names
    },
    enterLive: function (room) {
      // 进入直播
      // console.log(room)
      if (room.status != 0) return;
      let routerUrl = '/stuLiveRoom'
      let type = this.$store.getters.getUserType
      if (this.$store.getters.getUserType === 2) {
        routerUrl = '/assistantLiveRoom'
      }
      let routeData = this.$router.resolve({
        path: routerUrl,
        query: {mid: room.live_id, gid: room.group_id}
      })
      window.open(routeData.href, '_blank')
    },
    enterPlayback: function (room) {
      // 进入回放
      let routerUrl = '/playbackRoom'
      let routeData = this.$router.resolve({
        path: routerUrl,
        query: {mid: room.live_id, gid: room.group_id}
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style scoped>
.content {
  padding-top: 20px;
  padding-bottom: 20px;
  padding-right: 10px;
  border-bottom: 1px solid #E7E7E7;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

}
.left {
/*  float: left; */
}
.right {
/*  padding-left: 10px; */
  overflow: auto;
}
.room-title {
  font-family: 'PingFangSC-Regular';
  font-size: 16px;
  color: #666666;
  letter-spacing: 0;
  text-align: justify;
  max-width: 300px;
  max-lines: 1;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.teachers {
  padding-top: 5px;
  font-family: 'PingFangSC-Regular';
  font-size: 14px;
  color: #666666;
  letter-spacing: 0;
  text-align: justify;
}
.room-time {
  padding-top: 5px;
  font-family: 'PingFangSC-Regular';
  font-size: 14px;
  color: #999999;
  letter-spacing: 0;
}
.pointer {
  cursor: pointer;
}

.no-data-wrap{
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.name-style{
  display: inline-block;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
  max-width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/components/live/Liverooms.vue